import { isTabsEnabledForWorkspace } from './components/tab-enablement';

export const isLabelledFeedResourceEnabled = (cloudId: string | null | undefined): boolean =>
	!!cloudId && isTabsEnabledForWorkspace(cloudId);
